import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const planSetupPageRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-setup',
	path: '/jira/plans/:planId/setup',
};
